import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
    EuiIconModule,
    EuiButtonModule,
} from '../../components';

import { EuiOverlayModule } from '../eui-overlay/eui-overlay.component';

import { EuiSearchComponent } from './search.component';

@NgModule({
    imports: [
        CommonModule,
        EuiIconModule,
        EuiButtonModule,
        EuiOverlayModule,
    ],
    exports: [
        EuiSearchComponent,
    ],
    declarations: [
        EuiSearchComponent,
    ],
})
export class EuiSearchModule {
}
